import EventService from "@/services/Event.js"

const state = {
    checkins: [],
    doPagination: true,
    pagination: {
        page: 1,
        page_size: 12
    }
}


const getters = {
    checkins: state => state.checkins,
    pagination: state => state.pagination,
    doPagination: state => state.doPagination,
}


const mutations = {
    SET_CHECKINS(state, checkins) {
        if (state.checkins.length > 0) {
            state.checkins = state.checkins.concat(checkins)
        } else {
            state.checkins = checkins
        }
    },
    CLEAR_CHECKINS(state) {
        state.doPagination = true
        state.pagination.page = 1
        state.checkins = []
        state.checkins = JSON.parse(JSON.stringify(state.checkins))
    },
    SET_DO_PAGINATION(state, doPagination) {
        state.doPagination = doPagination
    },
    INCREMENT_PAGINATION(state) {
        state.pagination.page += 1
    },

    SET_CHECKIN_PHOTOS(state, {checkinId, photos}) {
        const index = state.checkins.findIndex(i => i.id === checkinId)
        state.checkins[index].photos = photos
        state.checkins[index].loaded = true
        // deep clone to force re-rendering
        state.checkins = JSON.parse(JSON.stringify(state.checkins))
    },
    UPDATE_CHECKIN(state, checkin) {
        const index = state.checkins.findIndex(i => i.id === checkin.id)
        state.checkins[index] = checkin
        // deep clone to force re-rendering
        state.checkins = JSON.parse(JSON.stringify(state.checkins))
    },

    REMOVE_CHECKIN(state, checkinId) {
        const index = state.checkins.findIndex(i => i.id === checkinId)
        state.checkins.splice(index, 1)
    }
}


const actions = {
    getCheckins(context, params) {
        return EventService.getCheckins(params)
            .then(response => {
                context.commit('SET_CHECKINS', response.data.results)
                return response.data.results
            })
            .catch(function (error) {
                return error
            })
    },
    getCheckinPhotos(context, {checkinId, params}) {
        return EventService.getCheckinPhotos(checkinId, params)
            .then(response => {
                context.commit('SET_CHECKIN_PHOTOS', {checkinId: checkinId, photos: response.data})
                return response.data
            })
            .catch(function (error) {
                return error
            })
    },
    /**
     * Updates a specific checkin; this is used to update a single album in the Event list gallery
     * whenever a new WebSocket event "checkin.new_medias_found" comes in
     */
    updateCheckin(context, checkinId) {
        return EventService.getCheckin(checkinId)
            .then(response => {
                context.commit('UPDATE_CHECKIN', response.data)
                return response.data
            })
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
